import React from 'react';
import PropTypes from 'prop-types';

function DispenseReportNotification({onSeeDetails = () => {}}) {
  return (
    <div style={{display: 'flex', flexDirection: 'column'}}>
      <div>Protocol execution is successfully finished</div>
      <br />
      <div style={{display: 'flex', justifyContent: 'flex-end', cursor: 'pointer'}} onClick={onSeeDetails}>
        SEE DETAILS
      </div>
    </div>
  );
}

DispenseReportNotification.propTypes = {
  onSeeDetails: PropTypes.func.isRequired,
};

export default DispenseReportNotification;
